// extracted by mini-css-extract-plugin
export default {"EditBodyRoot":"ScheduleEditBody_EditBodyRoot__lsoIA"};